export const ApiDef_DiseaseView = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map